// extracted by mini-css-extract-plugin
export default {"container":"MapPage_container__JH54J","legends":"MapPage_legends__k3Ga8","loadingStatusPanel":"MapPage_loadingStatusPanel__hO8D-","bottomContainer":"MapPage_bottomContainer__mnsC8"};